/* React */
import React from "react";

/* Stylesheet */
import styles from "./EmptyDataContainer.module.scss";

/* Interfaces */
interface EmptyDataContainerProps {
  img?: string;
  label?: string;
  scssProps?: ScssProps;
}

interface ScssProps {
  img?: {
    width?: string;
  };
}

const EmptyDataContainer: React.FC<
  EmptyDataContainerProps
> = ({ img, label, scssProps }) => {
  return (
    <div className={styles.empty_data_container}>
      {label ? (
        <div className={styles.label_container}>
          <div className={styles.label}>{label}</div>
        </div>
      ) : undefined}
      <img
        className={styles.image}
        width={scssProps?.img?.width}
        src={img}
      />
    </div>
  );
};

export default EmptyDataContainer;
